export const LOCIZE_NAMESPACE: string = 'WEBSITE'
